import { getStore } from "../stores/base";
import { errorMsg, msgData } from "./utils";

export const getPageParams = (pageId, data) => {
  try {
    const { key } = data;
    // eslint-disable-next-line no-unused-vars
    const usePageDevStore = getStore(`runtime_page_${pageId}`);
    const pageParams = usePageDevStore.getState().getPageInputs();
    return msgData(data, {
      value: pageParams?.[key]
    });
  } catch (e) {
    return errorMsg(data, e);
  }
};

export const getAllPageParams = (pageId, data) => {
  try {
    // eslint-disable-next-line no-unused-vars
    const usePageDevStore = getStore(`runtime_page_${pageId}`);
    const pageParams = usePageDevStore.getState().getPageInputs();
    return msgData(data, pageParams);
  } catch (e) {
    return errorMsg(data, e);
  }
};

export const openPopup = (pageId, data) => {
  try {
    let { popupId, popupParams } = data;
    let usePageStore = getStore(`runtime_page_${pageId}`);
    let pageMeta = usePageStore.getState().pageMetadata;
    let popupMeta = pageMeta.getObject(popupId);
    if (!popupMeta) {
      return errorMsg(data, { message: `Popup ${popupId} not found` });
    }
    if (popupParams) {
      usePageStore.getState().updatePopupContext(popupId, popupParams);
    }
    usePageStore.getState().pushToPopupList(popupMeta);
  } catch (e) {
    return errorMsg(e);
  }
};

export const closePopup = (pageId) => {
  try {
    let usePageStore = getStore(`runtime_page_${pageId}`);
    usePageStore.getState().dequeuePopup();
  } catch (e) {
    return errorMsg(e);
  }
};

export const getPageVariable = (pageId, data) => {
  try {
    const { key } = data;
    let usePageStore = getStore(`runtime_page_${pageId}`);
    const value = usePageStore.getState().pageVariables[key];
    let result = msgData(data, {
      value
    });
    return result;
  } catch (e) {
    return errorMsg(data, e);
  }
};

export const setPageVariable = (pageId, data) => {
  try {
    let resp;
    const { key, value } = data;
    let usePageStore = getStore(`runtime_page_${pageId}`);
    if (typeof key === "string") {
      resp = usePageStore.getState().updatePageVariable({ [key]: value });
    } else if (typeof key === "object") {
      resp = usePageStore.getState().updatePageVariable(key);
    }
    return msgData(data, {
      ...resp
    });
  } catch (e) {
    return errorMsg(data, e);
  }
};
